import { Expense } from "@/types/expense";
import { format } from "date-fns";
import { IndianRupee, User, Users } from "lucide-react";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface TripExpenseDetailsProps {
  expense: Expense;
}

export const TripExpenseDetails = ({ expense }: TripExpenseDetailsProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      className="p-4 rounded-lg bg-white/50 border border-gray-100"
    >
      <div className="flex justify-between items-start">
        <div>
          <h4 className="font-medium text-gray-900">{expense.description}</h4>
          <p className="text-sm text-gray-500">
            {format(new Date(expense.date), "PPP")}
          </p>
          <div className="flex flex-wrap gap-2 mt-2">
            <Badge variant="outline" className="bg-primary/10">
              {expense.category}
            </Badge>
            {expense.paidBy && (
              <Badge variant="secondary" className="flex items-center gap-1">
                <User className="h-3 w-3" />
                Paid by {expense.paidBy}
              </Badge>
            )}
            {expense.participants && expense.participants.length > 0 && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger>
                    <Badge variant="outline" className="flex items-center gap-1">
                      <Users className="h-3 w-3" />
                      Split among {expense.participants.length}
                    </Badge>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>{expense.participants.join(", ")}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
        </div>
        <div className="flex items-center gap-1 text-lg font-semibold text-primary">
          <IndianRupee className="h-4 w-4" />
          {expense.amount.toFixed(2)}
        </div>
      </div>
    </motion.div>
  );
};